var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99973 8.9333L4.73306 12.2C4.61084 12.3222 4.45528 12.3833 4.26639 12.3833C4.07751 12.3833 3.92195 12.3222 3.79973 12.2C3.67751 12.0777 3.61639 11.9222 3.61639 11.7333C3.61639 11.5444 3.67751 11.3889 3.79973 11.2666L7.06639 7.99997L3.79973 4.7333C3.67751 4.61108 3.61639 4.45553 3.61639 4.26664C3.61639 4.07775 3.67751 3.92219 3.79973 3.79997C3.92195 3.67775 4.07751 3.61664 4.26639 3.61664C4.45528 3.61664 4.61084 3.67775 4.73306 3.79997L7.99973 7.06664L11.2664 3.79997C11.3886 3.67775 11.5442 3.61664 11.7331 3.61664C11.922 3.61664 12.0775 3.67775 12.1997 3.79997C12.3219 3.92219 12.3831 4.07775 12.3831 4.26664C12.3831 4.45553 12.3219 4.61108 12.1997 4.7333L8.93306 7.99997L12.1997 11.2666C12.3219 11.3889 12.3831 11.5444 12.3831 11.7333C12.3831 11.9222 12.3219 12.0777 12.1997 12.2C12.0775 12.3222 11.922 12.3833 11.7331 12.3833C11.5442 12.3833 11.3886 12.3222 11.2664 12.2L7.99973 8.9333Z",
    fill: "#777777"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.a9d04700caf3e3d1fccab25d9cab5192.svg";
export { ForwardRef as ReactComponent };